export default __webpack_public_path__ + "static/media/filter_default(2).e987d55e.svg";